<template>
  <div class="ly_top">
    <div class="el_top_title">
      人づきあいのスキル診断へのご参加<br />ありがとうございました。
    </div>
    <div class="el_top_thank">
      Thank You!
    </div>
    <div class="el_top_text">
      研究チーム : 教育テスト研究センター(CRET)<br />
      研究代表者 :<br />
      澤海 崇文(t.sawaumi@gmail.com) <br />
      共同研究者 : <br />
      酒井 智弘・能渡 真澄・相川 充
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
}
</script>

<style scoped>
.ly_top {
  position: relative;
  top: 60px;
}
.el_top_title {
  position: relative;
  height: 71px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 70px;

  color: #6b6b6b;
}
.el_top_thank {
  position: relative;
  top: 100px;
  height: 71px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 80px;
  line-height: 70px;

  color: #ffa4a4;
}
.el_top_text {
  position: relative;
  width: 528px;
  height: 149px;
  top: 160px;

  text-align: left;

  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;

  color: #6b6b6b;
}
</style>
